import React, { useEffect, useRef, useState } from "react";
import {
	ErrorNotiLogin,
	FomrmLoginButton,
	FomrmLoginCreateOne,
	FomrmLoginCreateOneText,
	FomrmLoginCreateOneWrap,
	FomrmLoginInput,
	FomrmLoginInput2,
	FomrmLoginWrap,
	ForgotYourPassword,
	NoteErrorNotiLogin,
} from "../styled/LoginStyles";
import useLogin from "../hook/useLogin";
import { push } from "@whalelo/audit-client";

export default function FomrmLogin(props: {
	setOpenDialog: (value: boolean) => void;
	setIsDialogOpenCreate: (value: boolean) => void;
	setIsDialogOpenForgot: (value: boolean) => void;
}) {
	const [loading, setLoading] = useState(false);
	const { doLogin, errorMess } = useLogin({ setOpenDialog: props.setOpenDialog, setLoading: setLoading });
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [localErrorMess, setLocalErrorMess] = useState("");

	const handleLogin = async () => {
		if (!email || !password) {
			setLocalErrorMess("Invalid email or password. Please try again.");
			return;
		}
		setLocalErrorMess("");
		setLoading(true);
		push({
			app: "admin",
			category: "auth",
			action: "auth.login",
			occurred_at: new Date().toISOString(),
			severity: 1,
			summary: `Admin login attempt: ${email}`,
			meta: null,
		});
		await doLogin(email, password);
		setLoading(false);
	};

	const handleCreateOne = async () => {
		props.setIsDialogOpenCreate(true);
		props.setOpenDialog(false);
	};
	const handleForgotPass = async () => {
		props.setIsDialogOpenForgot(true);
		props.setOpenDialog(false);
	};

	return (
		<FomrmLoginWrap>
			<FomrmLoginInput
				placeholder="Email"
				value={email}
				onChange={(e) => setEmail(e.target.value)}
				onKeyDown={(e) => {
					if (e.key === "Enter") {
						handleLogin();
					}
				}}
			/>
			<FomrmLoginInput2
				placeholder="Password"
				type="password"
				value={password}
				onChange={(e) => setPassword(e.target.value)}
				onKeyDown={(e) => {
					if (e.key === "Enter") {
						handleLogin();
					}
				}}
			/>
			{localErrorMess || errorMess ? (
				<ErrorNotiLogin>{localErrorMess || errorMess}</ErrorNotiLogin>
			) : (
				<NoteErrorNotiLogin></NoteErrorNotiLogin>
			)}
			<ForgotYourPassword onClick={handleForgotPass}>Forgot your password</ForgotYourPassword>
			<FomrmLoginButton
				onClick={handleLogin}
				disabled={loading}
				$loading={loading}>
				{loading ? "Logging in..." : "Log in"}
			</FomrmLoginButton>
			<FomrmLoginCreateOneWrap>
				<FomrmLoginCreateOneText>Don’t have an account?</FomrmLoginCreateOneText>
				<FomrmLoginCreateOne onClick={handleCreateOne}>Create One</FomrmLoginCreateOne>
			</FomrmLoginCreateOneWrap>
		</FomrmLoginWrap>
	);
}
